import React from 'react';
import PropTypes from 'prop-types';
import UserAvatar from 'components/UserAvatar';
import DefaultUserImage from 'resources/default_user_image.png';
import './ProfileIcon.css';

function ProfileIcon({
  onClick,
  size,
  src,
  legacyAvatarUrl,
  withBorder,
  className,
  alt = '',
  avatarData,
  showLegacyFeed,
  withBackground = true
}) {
  const srcImg = src || legacyAvatarUrl || DefaultUserImage;
  const border = withBorder ? 'with-border' : '';
  className = className || '';

  return (
    <React.Fragment>
      {typeof avatarData !== 'undefined' && !showLegacyFeed ? (
        <UserAvatar
          avatarData={avatarData}
          withBackground={withBackground}
          classNames={`size-${size} ${border} ${className}`}
          {...(onClick ? { onClick: onClick } : {})}
        />
      ) : (
        <div className={`profile-icon size-${size} ${border} ${className}`}>
          {onClick && (
            <button type="button" onClick={onClick}>
              <img src={srcImg} alt={alt} />
            </button>
          )}
          {!onClick && <img src={srcImg} alt={alt} />}
        </div>
      )}
    </React.Fragment>
  );
}

ProfileIcon.propTypes = {
  onClick: PropTypes.func,
  src: PropTypes.string,
  legacyAvatarUrl: PropTypes.string,
  size: PropTypes.number,
  withBorder: PropTypes.bool,
  showLegacyFeed: PropTypes.bool,
  className: PropTypes.string,
  alt: PropTypes.string
};

export default ProfileIcon;
